import {React} from 'common'
import MessageIcon from '@mui/icons-material/Message'
import {Badge} from '@mui/material'
import {getPendingMediasCount} from 'services/utils'
import {useGetUserDancesQuery} from 'store/Store'

const NotificationBadge = () => {
    const {data: userDances} = useGetUserDancesQuery()
    const pendingMediasCount = getPendingMediasCount(userDances)

    return (
        <Badge badgeContent={pendingMediasCount} color="error">
            <MessageIcon color="action" />
        </Badge>
    )
}

export default NotificationBadge
